const API_URL = "https://dev.dimalink.cl/api/Valvulas";

/**
 * Crear válvula
 */
export async function crearValvula(valvula) {
  try {
    const response = await fetch(`${API_URL}/crear`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(valvula),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al crear válvula:", error);
    throw error;
  }
}

/**
 * Modificar válvula
 */
export async function modificarValvula(valvula) {
  try {
    const response = await fetch(`${API_URL}/modificar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(valvula),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al modificar válvula:", error);
    throw error;
  }
}

/**
 * Desactivar válvula
 */
export async function desactivarValvula(valvula) {
  try {
    const response = await fetch(`${API_URL}/desactivar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(valvula),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al desactivar válvula:", error);
    throw error;
  }
}

/**
 * Activar válvula
 */
export async function activarValvula(valvula) {
  try {
    const response = await fetch(`${API_URL}/activar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(valvula),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al activar válvula:", error);
    throw error;
  }
}
